import { ComboboxItem, MultiSelect as MantineMultiSelect, MultiSelectProps } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons-react";
import { forwardRef, Ref, useState } from "react";

import classes from "./inputs/InputStyles.module.css";

const MULTI_SELECT_INNER_INPUT_MIN_WIDTH = 1;
const MULTI_SELECT_INNER_INPUT_MAX_WIDTH = 150;

export const MultiSelectInput = forwardRef(
  (
    props: Omit<MultiSelectProps, "data"> & {
      withEmptyData?: boolean;
      data: ComboboxItem[];
      size?: "sm" | "md";
    },
    ref: Ref<HTMLInputElement> | undefined,
  ) => {
    const { label, required, data, withEmptyData, size = "md", ...rest } = props;

    const [searchValue, setSearchValue] = useState("");

    const extendedData = data.map((item) => {
      if (typeof item === "string") {
        return item;
      }

      return {
        value: item.value,
        label: item.label,
      };
    });

    if (withEmptyData) {
      extendedData.unshift({ value: "", label: "" });
    }

    const hasPlaceholder = Boolean(rest.placeholder && rest.placeholder.length);

    return (
      <MantineMultiSelect
        classNames={{
          input: size === "sm" ? classes.smallInput : classes.input,
        }}
        ref={ref}
        {...rest}
        data={extendedData}
        rightSection={<IconChevronDown size="1rem" />}
        styles={{
          section: { pointerEvents: "none" },
          input: {
            fontSize: size === "sm" ? 10 : undefined,
            opacity: 1,
          },
          option: {
            fontSize: size === "sm" ? 10 : undefined,
          },
          pill: {
            fontSize: size === "sm" ? 10 : undefined,
            height: size === "sm" ? 16 : undefined,
            "--pill-height": size === "sm" ? "16px" : undefined,
          },
          inputField: {
            width: hasPlaceholder ? undefined : `${searchValue.length}ch`,
            minWidth: hasPlaceholder ? undefined : MULTI_SELECT_INNER_INPUT_MIN_WIDTH,
            maxWidth: MULTI_SELECT_INNER_INPUT_MAX_WIDTH,
            fontSize: size === "sm" ? 10 : undefined,
          },
        }}
        required={required}
        label={label}
        searchValue={searchValue}
        onSearchChange={setSearchValue}
      />
    );
  },
);
